import $ from 'jquery';
import constants from '../../constants';

export default class JumpMenuHandler {
    constructor() {
        this.setupEvents();
        this.renderAnchors();
    }

    setupEvents() {
        $(document).on('click', '[' + constants.BLOCK_JUMP_MENU_ANCHOR_LINK_ATTR + ']', (ev) => { this.onAnchorLinkClick(ev); })
    }

    onAnchorLinkClick(ev) {
        ev.preventDefault();
        const $target = $(ev.currentTarget);
        const id = $target.attr('href');
        const scrollTop = $(id).offset().top - constants.FADE_IN_SCROLL_PX_OFFSET;

        $('html, body').animate({
            scrollTop: scrollTop
        }, 500);
    }

    renderAnchors() {
        const links = $(constants.BLOCK_JUMP_MENU_ANCHOR_SELECTOR).toArray().map((el) => {
            const $el = $(el)
            const title = $el.attr(constants.BLOCK_JUMP_MENU_ANCHOR_ATTR_TITLE);
            const id = $el.attr(constants.BLOCK_JUMP_MENU_ANCHOR_ATTR_ID);

            if (title) {
                return '<a class="' + constants.BLOCK_JUMP_MENU_INTERNAL_LINK_CLASS + ' jump-menu-link jump-menu-link--down" ' + constants.BLOCK_JUMP_MENU_ANCHOR_LINK_ATTR + ' href="#' + id + '"><span class="jump-menu-link__label">' + title + '</span></a>';
            }
        });

        $(constants.BLOCK_JUMP_MENU_ANCHOR_TARGET_SELECTOR).html(links.join(''));
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/Blocks/JumpMenuHandler.js